/**********************************************************
 *  Imports
 **********************************************************/

// RequestHandler
import RequestHandler from './RequestHandler.js';

/**********************************************************
 * 
 *  ClientRoutes maintains all of the routes/calls to the 
 *  backend.
 *  
 **********************************************************/


/**********************************************************
 *  Currencies
 **********************************************************/

// Fetch a pre-made list of currencies
function getCurrencyList() {

	//console.log('ClientRoutes.getCurrencyList()');

    return RequestHandler.getRequest('/app/currencies/all', false);

}


// Fetch a list of exchanges and all quote currencies
function getExchangeList() {
    
    //console.log('ClientRoutes.getExchangeList()');

    return RequestHandler.getRequest('/app/exchanges/all', false);

}

/**********************************************************
 *  Prices
 **********************************************************/

// Gets all prices from pricing service
function getAllPrices() {

    //console.log('ClientRoutes.getAllPrices()');

    return RequestHandler.getRequest('/app/prices/all', false);
}


// Returns the socket connection details
function getSocketConnection() {

    //console.log('ClientRoutes.getSocketConnection()');

    return RequestHandler.getRequest('/app/socketConnection', false);

}


/**********************************************************
 *  Charting
 **********************************************************/

// Given a ticker, exchange and quoteCurrency and interval,
// return the proper chart
function getChart(exchange, ticker, quoteCurrency, interval) {

    //console.log('ClientRoutes.getChart()');
    
    var endpoint = `/app/chart/` + exchange + `/` + ticker + `/` + quoteCurrency + `/` + interval;

    return RequestHandler.getRequest(endpoint, false);
    
} 


/**********************************************************
 *  Pnl
 **********************************************************/

// Retrieve a user's pnl
function getPnl(username) {

    //console.log('ClientRoutes.getPnl()');
    
    var endpoint = `/app/user/pnl/` + username;

    return RequestHandler.getRequest(endpoint, true);

}


// Retrieve a user's historical pnl
function getHistPnl(username, days) {
    
    //console.log('ClientRoutes.getHistPnl()');
    
    var endpoint = `/app/user/histpnl/` + username + `/` + days;

    return RequestHandler.getRequest(endpoint, true);

}

// Create a pnl profile for user
function createPnlUser(username) {

    //console.log('ClientRoutes.createPnlUser()');
    
    var endpoint = `/app/user/pnl/newUser/` + username;

    return new Promise ( (resolve, reject) => {

        RequestHandler.getRequest(endpoint, true)
            .then( (response) => resolve(true) )
            .catch( (error) => reject(error) );

    });

}


// Given a token, retrieve a user's open orders
function getOrders(username) {
    
    //console.log('ClientRoutes.getOrders()');
    
    var endpoint = `/app/user/orders/` + username;

    return RequestHandler.getRequest(endpoint, true);
}


// Given a token, retrieve a user's open positions
function getPositions(username) {
    
    //console.log('ClientRoutes.getPositions()');
    
    var endpoint = `/app/user/positions/` + username;

    return RequestHandler.getRequest(endpoint, true);
}

/**********************************************************
 *  ApiKeys
 **********************************************************/

// Saves an apikey
function saveApiKey(key, username) {

    //console.log('ClientRoutes.getBalances()');
    
    var endpoint = `/app/apikey/save/` + username;

    return RequestHandler.postRequest(endpoint, key, false);

}


// Retrieves the api keys for a given user
function getApiKeys(username) {

    //console.log('ClientRoutes.getApiKeys()');
    
    var endpoint = `/app/apikeys/` + username;

    return RequestHandler.getRequest(endpoint, true);

}


// Deletes the api key for a user
function deleteApiKey(username, apiKey) {
    
    //console.log('ClientRoutes.deleteApiKey()');
    
    var endpoint = `/app/apikey/delete/` + username;

    return RequestHandler.postRequest(endpoint, apiKey, true);

}

/**********************************************************
 *  Market Cap Routes
 **********************************************************/

// Return the overall market cap details
function getMarketCapDetails() {

    //console.log('ClientRoutes.getMarketCapDetails()');

    return RequestHandler.getRequest('/app/marketcap/details', false);

}

// Given a count and a currency, return the marketcap details
function getMarketCaps(currency, count) {

    //console.log('ClientRoutes.getMarketCaps()');

    var endpoint = `/app/marketcap/` + currency + `/` + count;

    return RequestHandler.getRequest(endpoint, false);

}

/**********************************************************
 *  News Routes
 **********************************************************/

 function getNews(filter, timestamp) {

    //console.log('ClientRoutes.getNews()');
    
    var endpoint = `/app/news/` + filter + '/' + timestamp;

    return RequestHandler.getRequest(endpoint, false);

 }

/**********************************************************
 *  News Routes
 **********************************************************/

// Return app details
function getAppDetails() {

    return RequestHandler.getRequest('/app/details', false);

}

// Return the statuses of all yety services
function getServiceStatuses() {

    return RequestHandler.getRequest('/app/statuses', false);

}


/**********************************************************
 *  Definitions
 **********************************************************/

const ClientRoutes = { 
    // currencies
    getCurrencyList, getExchangeList, 

    // prices
    getAllPrices, getSocketConnection, getMarketCapDetails, getMarketCaps,

    // charting
    getChart, 

    // pnl
    getPnl, getHistPnl, createPnlUser, getOrders, getPositions, 

    // apikeys
    saveApiKey, getApiKeys, deleteApiKey,

    // news
    getNews,

    // details
    getAppDetails, getServiceStatuses
};

export default ClientRoutes;



// WEBPACK FOOTER //
// ./src/Routes/ClientRoutes.js